import { YouTubeEmbed as YouTubeEmbedBase } from "@next/third-parties/google";
import { ComponentProps } from "react";

type Props = ComponentProps<typeof YouTubeEmbedBase>;

export const YouTubeEmbed = (props: Props) => <YouTubeEmbedBase {...props} />;
